import React from 'react';
import BaseModal from '../baseModal';
import './style.scss';

import { useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const SharingModal = ({ show, txId, close }) => {
  const [openSnackBar, setOpenSnackBar] = useState(false);
  const [snackBarMsg, setsnackBarMsg] = useState('');
  const closeSnackBar = () => {
    setOpenSnackBar(false);
  }
  const navigate = navigator;
  const fullUrl = window.location.origin + '/' + txId;
  const copyShareLink = () => {
    navigate.clipboard.writeText(fullUrl);
    setsnackBarMsg('Message Url Copied!');
    setOpenSnackBar(true);
  }
  return (
    <>
      <BaseModal show={show} handleClose={close}>
        <div className="broadcast-modal-tx__buttons">
          <div id="share-form-container">
            <button className="button" onClick={copyShareLink}>Copy Message URL</button>
          </div>
        </div>
      </BaseModal>
      {/* Snack bar joint */}
      <Snackbar open={openSnackBar} autoHideDuration={6000} onClose={closeSnackBar}>
        <Alert onClose={closeSnackBar} severity="success" sx={{ width: '100%' }}>
          {snackBarMsg}
        </Alert>
      </Snackbar>
    </>
  )
}

export default SharingModal;